import React from 'react';

interface AvatarProps {
  src: string | null | undefined;
  size?: number;
  name?: string;
}

const getInitials = (name?: string) => {
  if (!name) return '';
  const parts = name.trim().split(' ');
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || '';
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Avatar: React.FC<AvatarProps> = ({ src, size = 96, name }) => {
  const [imgError, setImgError] = React.useState(false);
  const [imgLoading, setImgLoading] = React.useState(true);
  const initials = getInitials(name);

  React.useEffect(() => {
    if (src) {
      setImgError(false);
      setImgLoading(true);
    }
  }, [src]);

  if (!src || imgError) {
    return (
      <div
        className="rounded-full bg-gray-300 flex items-center justify-center text-white font-bold"
        style={{ width: size, height: size, fontSize: size ? size / 2.5 : 32 }}
        title={name}
      >
        {initials || '?'}
      </div>
    );
  }

  return (
    <div style={{ width: size, height: size, position: 'relative' }}>
      {imgLoading && (
        <div
          className="rounded-full bg-gray-300 flex items-center justify-center text-white font-bold absolute inset-0"
          style={{ fontSize: size ? size / 2.5 : 32 }}
        >
          {initials || '?'}
        </div>
      )}
      <img
        className="rounded-full"
        height={size}
        width={size}
        alt={name || 'Avatar'}
        src={src}
        onLoad={() => setImgLoading(false)}
        onError={() => {
          setImgError(true);
          setImgLoading(false);
        }}
        style={{ display: imgLoading ? 'none' : 'block' }}
      />
    </div>
  );
};

export default Avatar;
